import { axiosInstance } from '../../api/api';
import { OPERATIONS } from '../../constants';
import * as ActionTypes from '../actionTypes';
import { updateCurrentLineItem } from './station';
import { fetchReceiveDetails } from './receiveDetails';

export const receivePart =
	(serialNumber, successCallback, errorCallback) => (dispatch, getState) => {
		const {
			station: { currentLineItem },
		} = getState();

		axiosInstance
			.post(`/station/receive/${serialNumber}`)
			.then(async () => {
				dispatch(updateReceivePart({ serialNumber }));
				dispatch(fetchReceiveDetails());
				try {
					const { data } = await axiosInstance.get('/station/current-part');
					if (data) {
						dispatch(
							updateCurrentLineItem({
								...currentLineItem,
								...data,
								completedOperations: [
									...new Set([
										...(currentLineItem.completedOperations || []),
										...data.completedOperations,
										OPERATIONS.RECEIVE_PART,
									]),
								],
							}),
						);
					} else {
						dispatch(
							updateCurrentLineItem({
								...currentLineItem,
								completedOperations: [
									...new Set([
										...(currentLineItem.completedOperations || []),
										OPERATIONS.RECEIVE_PART,
									]),
								],
							}),
						);
					}
					successCallback();
				} catch (error) {
					dispatch(
						updateCurrentLineItem({
							...currentLineItem,
							completedOperations: [
								...new Set([
									...(currentLineItem.completedOperations || []),
									OPERATIONS.RECEIVE_PART,
								]),
							],
						}),
					);
					errorCallback(error);
				}
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export const updateReceivePart = (data) => (dispatch, getState) => {
	const { user } = getState();
	const { station } = user;

	const state = { ...data };

	const lineAndStationDataInLocalStorage =
		JSON.parse(localStorage.getItem(station.replaceAll(/[- ]/g, '_'))) || {};

	const lineAndStationData = {
		...lineAndStationDataInLocalStorage,
		receivePart: state,
	};
	localStorage.setItem(
		station.replaceAll(/[- ]/g, '_'),
		JSON.stringify(lineAndStationData),
	);

	dispatch({
		type: ActionTypes.UPDATE_RECEIVE_PART,
		...state,
	});
};
